import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { TaskInterface } from '@vendasta/task';

export const OrderFulfillmentServiceInterfaceToken: InjectionToken<OrderFulfillmentServiceInterface> =
  new InjectionToken<OrderFulfillmentServiceInterface>('OrderFulfillmentServiceInterface');

export interface OrderFulfillmentTableRow {
  template: TaskInterface;
  serviceProviderName: string;
  productName: string;
  isCurrentPartner?: boolean;
}

export interface OrderFulfillmentServiceInterface {
  tableRows$: Observable<OrderFulfillmentTableRow[]>;
}
